<template>
	<div
		v-if="show"
		class="modal modal-custom fade show"
		tabindex="-1"
		role="dialog"
		style="display: block"
	>
		<div class="modal-dialog modal-dialog-centered modal-xl" role="document">
			<div class="modal-content">
				<div class="modal-header">
					<h5 class="modal-title">Enter Connection Details</h5>
					<button type="button" class="close" @click="closeModal()" aria-label="Close">
						<span aria-hidden="true">&times;</span>
					</button>
				</div>
				<div class="modal-body">
					<form @submit.prevent="submitForm" class="row d-flex">
						<div class="col-md-6 d-flex flex-column">
							<input
								v-model="customPmsSettings.pmsEmailSettings.username"
								type="text"
								placeholder="Username"
								class="form-control mb-2"
							/>
							<input
								v-model="customPmsSettings.pmsEmailSettings.password"
								type="password"
								placeholder="Password"
								class="form-control mb-2"
							/>
							<input
								v-model="customPmsSettings.pmsEmailSettings.csv_separator"
								type="text"
								placeholder="CSV Separator (Examples: `,` `|` `TAB` )"
								class="form-control mb-2"
							/>
							<input
								v-model="customPmsSettings.pmsEmailSettings.date_format"
								type="text"
								placeholder="Date Format (Examples: `Y-m-d`, `d-M-y`, `Y-m-d H:i:s`)"
								class="form-control mb-2"
							/>
							<span class="light-text text-uppercase ml-0">
								<strong>TEAM MAP</strong>
							</span>
							<div class="scrollable-container pl-1 pt-2">
								<div class="row align-items-start">
									<div class="col d-flex align-items-start pl-0 ml-0 mb-2">
										<select
											v-if="customPmsSettings.teamMapOptions.length > 0"
											v-model="customPmsSettings.selectedTeamMapColumn"
											class="form-control"
											@change="onTeamColumnSelected()"
										>
											<option
												v-for="option in customPmsSettings.teamMapOptions"
												:value="option"
											>
												{{ option }}
											</option>
										</select>
										<div v-else>
											<strong>Team Identifier Column:</strong
											><input
												v-model="
													customPmsSettings.pmsEmailSettings.team_column
												"
												type="text"
												class="form-control"
											/>
										</div>
									</div>
								</div>
								<div
									v-for="(field, index) in customPmsSettings.teamMapFields"
									:key="index"
									class="row align-items-start"
									:disabled="!customPmsSettings.pmsEmailSettings.team_column"
								>
									<div class="col d-flex align-items-start pl-0 ml-0 mb-2">
										<select
											v-if="
												customPmsSettings.selectedColumnValues[
													customPmsSettings.selectedTeamMapColumn
												]
											"
											v-model="field.columnName"
											class="form-control"
										>
											<option
												v-for="value in customPmsSettings
													.selectedColumnValues[
													customPmsSettings.selectedTeamMapColumn
												]"
												:value="value"
											>
												{{ value }}
											</option>
										</select>
										<input
											v-else
											v-model="field.columnName"
											type="text"
											placeholder="Team Column (e.g., HOTEL, C9)"
											class="form-control"
										/>
									</div>
									<div class="col-md-5">
										<div
											class="position-relative form-group"
											v-if="!field.selectedTeamName"
										>
											<div class="form-icon">
												<i class="fas fa-search"></i>
											</div>
											<input
												type="text"
												class="pl-5 form-control"
												v-model="field.searchQuery"
												placeholder="Type Property Name"
											/>
											<div class="dropdown-content" v-if="field.searchQuery">
												<div
													v-for="(teamName, teamIndex) in filteredTeams"
													:key="teamIndex"
												>
													<div
														class="dropdown-item"
														@click="
															addTeamToMap(
																teamName,
																index,
																field.columnName,
															)
														"
													>
														{{ teamName }}
													</div>
												</div>
											</div>
										</div>
										<input
											v-else
											type="text"
											class="form-control"
											:value="field.selectedTeamName"
											readonly
										/>
									</div>
									<div
										v-if="customPmsSettings.teamMapFields.length > 0"
										class="col-auto"
									>
										<button
											type="button"
											class="btn btn-danger"
											@click="removeTeamMap(index)"
										>
											-
										</button>
									</div>
								</div>
							</div>
							<span class="light-text text-uppercase ml-0">
								<strong>Field Map</strong>
							</span>
							<div class="scrollable-container pt-2">
								<draggable
									v-model="pmsEmailMappings"
									group="fields"
									handle=".drag-handle"
									@start="drag = true"
									@end="drag = false"
								>
									<div
										v-for="(item, index) in pmsEmailMappings"
										:key="index"
										class="row mb-2 align-items-center"
									>
										<div class="col-auto">
											<span class="drag-handle fas fa-bars"></span>
										</div>
										<div class="col">
											<select
												v-if="
													customPmsSettings.selectableColumns.length > 0
												"
												v-model="item.columnName"
												class="form-control"
											>
												<option
													v-for="columnName in customPmsSettings.selectableColumns"
													:value="columnName"
													:key="columnName"
													:disabled="filteredColumns[columnName]"
												>
													{{ columnName }}
												</option>
											</select>
											<input
												v-else
												v-model="item.columnName"
												type="text"
												placeholder="Field"
												class="form-control"
											/>
										</div>
										<div class="col">
											<select v-model="item.field" class="form-control">
												<option
													v-for="option in customPmsSettings.selectableFieldMappings"
													:value="option"
													:key="option"
													:disabled="filteredFieldMappings[option]"
												>
													{{ option }}
												</option>
											</select>
										</div>
										<div class="col-auto">
											<button
												type="button"
												class="btn btn-danger"
												@click="removeField(index)"
											>
												-
											</button>
										</div>
									</div>
								</draggable>
							</div>
						</div>
						<div class="col-md-6 d-flex">
							<div
								v-html="renderedMappings"
								class="form-control mb-2 flex-grow-1 styled-text-output"
								style="overflow-y: scroll; height: 100%; max-height: 650px"
							></div>
						</div>
					</form>
				</div>
				<div class="modal-footer d-flex justify-content-between">
					<div>
						<button type="button" class="btn btn-primary mr-1" @click="addTeamMapField">
							Add Team Map Field +
						</button>
						<button type="button" class="btn btn-primary" @click="insertMappingField">
							Add Field +
						</button>
						<button
							type="button"
							class="btn btn-primary mr-1"
							@click="triggerFileUpload"
						>
							Upload CSV
						</button>
						<input
							type="file"
							ref="fileInput"
							@change="handleFileUpload"
							style="display: none"
						/>
					</div>
					<div>
						<button type="button" class="btn btn-secondary" @click="closeModal()">
							Cancel
						</button>
						<button type="submit" class="btn btn-primary" @click="submitPmsEmailForm">
							Save
						</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import draggable from 'vuedraggable';
import SurveysService from '../../services/surveys-service';
export default {
	props: {
		teams: Array,
		team: Object,
		teamConnections: Array,
		show: Boolean,
	},

	data() {
		return {
			showPmsEmailModal: false,
			pmsEmailMappings: [],
			customPmsSettings: {
				csvRows: [],
				selectedTeamMapColumn: null,
				selectedColumnValues: {},
				teamMapOptions: [],
				pmsEmailSettings: {
					username: null,
					password: null,
					csv_separator: null,
					mapping: {},
					date_format: null,
					team_map: [],
					team_column: null,
				},
				selectableColumns: [],
				availableColumns: [],
				selectedCsvColumn: '',
				teamMapFields: [],
				selectableFieldMappings: [
					'email',
					'first_name',
					'last_name',
					'check_in_date',
					'check_out_date',
					'room_id',
					'booking_id',
					'team_identifier',
					'full_name_with_comma',
					'full_name_with_whitespace',
					'language_code',
					'title',
					'reservation_token',
				],
			},
			errorMessages: {
				'type.required': 'The type field is required and must be either email or ftp.',
				'username.required': 'Username is required.',
				'password.required': 'Password is required.',
				'csv_separator.required': 'CSV separator is required.',
				'date_format.required': 'Date format is required.',
				'team_column.required_with': 'Team column is required when team map is present.',
				'team_map.required_with': 'Team map is required when team column is present.',
				'required_with': 'This field is required due to the configuration of another field.',
				'mapping.required': 'Mapping information is required.',
				'mapping.not_allowed': 'One or more mapping values are not allowed.',
			},
		};
	},
	computed: {
		filteredFieldMappings() {
			const selectedFields = this.pmsEmailMappings.reduce((acc, mapping) => {
				if (mapping && mapping.field) {
					acc[mapping.field] = true;
				}
				return acc;
			}, {});
			const result = this.customPmsSettings.selectableFieldMappings.filter(
				(field) => selectedFields[field],
			);
			return Object.fromEntries([
				result.map((field) => [field, false]),
				...result.map((field) => [field, true]),
			]);
		},
		filteredColumns() {
			const selectedColumns = this.pmsEmailMappings.reduce((acc, mapping) => {
				if (mapping && mapping.columnName) {
					acc[mapping.columnName] = true;
				}
				return acc;
			}, {});
			const result = this.customPmsSettings.selectableColumns.filter(
				(field) => selectedColumns[field],
			);
			return Object.fromEntries([
				result.map((field) => [field, false]),
				...result.map((field) => [field, true]),
			]);
		},
		renderedMappings() {
			const pmsSettings = this.customPmsSettings.pmsEmailSettings;
			const mapping = this.pmsEmailMappings;
			const teamMappings = this.customPmsSettings.teamMapFields
				.filter((teamMap) => teamMap.columnName || teamMap.teamId)
				.map((teamMap) => ({
					columnName: teamMap.columnName,
					teamName: this.teams.find((team) => team.id === teamMap.teamId)?.name || '',
				}));
			const fieldMappings = mapping.filter((v) => v && v?.columnName && v?.field);

			let mappingsHtml = '';

			if (teamMappings.length > 0) {
				mappingsHtml += /*html*/ `
					<h2 class="mb-3">Team Map</h2>
					<div class="team-mappings">
						<p>
							<strong>Team Identifier Column:</strong>
							<span class="team-identifier text-primary font-weight-bold"
								>${pmsSettings.team_column}</span
							>
						</p>
						<br />
						<ul>
							${teamMappings
								.map(
									(teamMap) => /*html*/ `
										<li>
											<span class="text-primary font-weight-bold"
												>${teamMap.columnName}</span
											>
											<span class="fa fa-arrow-right mx-1"></span>
											<span class="text-primary font-weight-normal"
												>${teamMap.teamName}</span
											>
										</li>
									`,
								)
								.join('\n')}
						</ul>
					</div>
				`;
			}

			if (fieldMappings.length > 0) {
				mappingsHtml += /*html*/ `
					<div class="mb-2">
						<h2 class="mb-3">Field Mappings</h2>
						<ul>
							${mapping
								.map(({ columnName, field }) => {
									if (!columnName || !field) return;
									return /*html*/ `
										<li>
											<span class="text-primary font-weight-bold"
												>${columnName}</span
											>
											<span class="fa fa-arrow-right mx-1"></span>
											<span class="text-primary font-weight-normal"
												>${field}</span
											>
										</li>
									`;
								})
								.join('\n')}
						</ul>
					</div>
				`;
			}

			return mappingsHtml;
		},
		filteredTeams() {
			const selectedTeamNames = new Set(
				this.customPmsSettings.teamMapFields.map((field) => field.selectedTeamName),
			);
			const teamNames = new Set();
			this.customPmsSettings.teamMapFields.forEach((field) => {
				if (field.searchQuery) {
					const filteredTeams = this.teams.filter(
						(team) =>
							team.name.toLowerCase().includes(field.searchQuery.toLowerCase()) &&
							!selectedTeamNames.has(team.name),
					);
					filteredTeams.forEach((team) => teamNames.add(team.name));
				}
			});
			return Array.from(teamNames);
		},
	},
	watch: {
		show() {
			this.fetchPmsEmailSettings();
		},
		pmsEmailMappings: {
			deep: true,
			handler: function (newVal, oldVal) {
				this.customPmsSettings.pmsEmailSettings.mapping = newVal.reduce((acc, curr) => {
					acc[curr.columnName] = curr.field;
					return acc;
				}, {});
			},
		},
	},
	methods: {
		async addConnection(type) {
			if (type === 'email') {
				const postData = {
					type: 'email',
					connectionId: 'PmsEmailConnection',
				};
				try {
					await axios.post(`/api/admin/teams/${this.team.id}/add-connection`, postData);
					this.newConnectionId = '';
					this.$parent.getTeamConnections();
				} catch (error) {
					console.error('Error adding email connection:', error);
					this.handleError(error, 'Error adding email connection');
				}
			} else {
				this.show = true;
			}
		},
		closeModal() {
			this.$emit('modal-closed');
		},
		saveConnection() {
			this.addConnection('email');
			this.closeModal();
		},
		convertTeamIdsToNames() {
			const teamMapFieldsArray = [];
			const teamMapDynamicFieldsArray = [];
			this.customPmsSettings.teamMapFields.forEach((field) => {
				const teamId = parseInt(field.teamId, 10);
				if (!isNaN(teamId)) {
					const team = this.teams.find((t) => t.id === teamId);
					if (team) {
						const teamMapFields = {
							columnName: field.columnName,
							teamId: team.id,
						};
						const teamMapDynamicFields = {
							columnName: field.columnName,
							teamId: team.id,
							selectedTeamName: team.name,
						};
						teamMapFieldsArray.push(teamMapFields);
						teamMapDynamicFieldsArray.push(teamMapDynamicFields);
					} else {
					}
				}
			});
			this.customPmsSettings.teamMapFields = teamMapDynamicFieldsArray;
			this.customPmsSettings.pmsEmailSettings.team_map = teamMapFieldsArray;
		},
		convertTeamNamesToIds() {
			const teamMapFieldsArray = [];
			this.customPmsSettings.pmsEmailSettings.team_map.forEach((field) => {
				const teamId = parseInt(field.teamId, 10);
				if (!isNaN(teamId)) {
					const team = this.teams.find((t) => t.id === teamId);
					if (team) {
						const teamMapFields = {
							columnName: field.columnName,
							teamId: team.id,
						};
						teamMapFieldsArray.push(teamMapFields);
						teamMapDynamicFieldsArray.push(teamMapDynamicFields);
					} else {
					}
				}
			});
		},
		onTeamColumnSelected() {
			const { selectedTeamMapColumn, availableColumns } = this.customPmsSettings;
			this.customPmsSettings.pmsEmailSettings.team_column = selectedTeamMapColumn;

			this.customPmsSettings.selectableColumns = availableColumns.filter(
				(field) => field !== selectedTeamMapColumn,
			);

			this.customPmsSettings.teamMapFields = [
				{ columnName: null, teamId: null, selectedTeamName: '' },
			];
		},
		updateSelectedColumn(field) {
			field.columnName = '';
		},
		triggerFileUpload() {
			this.$refs.fileInput.click();
		},
		handleFileUpload(event) {
			const file = event.target.files[0];
			if (file) {
				const reader = new FileReader();
				reader.onload = (e) => {
					const content = e.target.result;
					this.processCSV(content);
				};
				reader.readAsText(file);
			}
		},
		updateTeamMapOptions() {
			this.customPmsSettings.teamMapOptions = [...this.customPmsSettings.selectableColumns];
		},
		processCSV(csvContent) {
			this.customPmsSettings.pmsEmailSettings.csv_separator =
				this.detectDelimiter(csvContent);
			const lines = csvContent.split('\n');
			this.customPmsSettings.selectableColumns = lines[0]
				.split(this.customPmsSettings.pmsEmailSettings.csv_separator)
				.map((header) => header.trim());
			this.customPmsSettings.selectedColumnValues = {};
			this.customPmsSettings.selectableColumns.forEach((column, columnIndex) => {
				const allValues = lines.slice(1).map((line) => {
					const rowData = line.split(
						this.customPmsSettings.pmsEmailSettings.csv_separator,
					);
					return rowData[columnIndex].trim();
				});
				this.customPmsSettings.selectedColumnValues[column] = Array.from(
					new Set(allValues),
				).filter(Boolean);
			});
			this.customPmsSettings.availableColumns = [...this.customPmsSettings.selectableColumns];
			this.updateTeamMapOptions();
		},
		detectDelimiter(csvContent) {
			const lines = csvContent.split('\n').slice(0, 5);
			const possibleDelimiters = [',', ';', '\t', '|', '/', ':', '\\', ' ', '-', '_', '.'];
			let maxCount = 0;
			let maxDelimiter = ',';
			possibleDelimiters.forEach((delimiter) => {
				let count = lines
					.map((line) => line.split(delimiter).length - 1)
					.reduce((a, b) => a + b, 0);
				if (count > maxCount) {
					maxCount = count;
					maxDelimiter = delimiter;
				}
			});
			if (maxDelimiter === ' ' || maxDelimiter === '\t') {
				return 'TAB';
			}
			return maxDelimiter;
		},
		detectDateFormat(dateString) {
			const formatPatterns = {
				'YYYY-MM-DD HH:mm:ss': /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/,
				'DD-MMM-YY': /^\d{2}-[A-Za-z]{3}-\d{2}$/,
				'DD/MM/YYYY': /^\d{2}\/\d{2}\/\d{4}$/,
				'YYYY-MM-DD': /^\d{4}-\d{2}-\d{2}$/,
				'M/D/YYYY': /^\d{1,2}\/\d{1,2}\/\d{4}$/,
			};
			for (const [format, pattern] of Object.entries(formatPatterns)) {
				if (dateString.match(pattern)) {
					return format;
				}
			}
			return 'Unknown Format';
		},
		removeTeamMap(index) {
			if (this.customPmsSettings.teamMapFields.length > 0) {
				this.customPmsSettings.teamMapFields.splice(index, 1);
				this.customPmsSettings.pmsEmailSettings.team_map.splice(index, 1);
			}
			if (this.customPmsSettings.teamMapFields.length === 0) {
				this.customPmsSettings.pmsEmailSettings.team_column = '';
				this.customPmsSettings.selectedTeamMapColumn = '';
			}
		},

		addTeamToMap(selectedTeam, index, columnName) {
			const team = this.teams.find((team) => team.name === selectedTeam);
			if (team) {
				if (!Array.isArray(this.customPmsSettings.pmsEmailSettings.team_map)) {
					this.customPmsSettings.pmsEmailSettings.team_map = [];
				}
				const teamMap = {
					teamId: team.id,
					columnName: columnName,
				};
				this.customPmsSettings.pmsEmailSettings.team_map.push(teamMap);
				this.$set(this.customPmsSettings.teamMapFields, index, {
					...this.customPmsSettings.teamMapFields[index],
					selectedTeamName: selectedTeam,
					teamId: team.id,
					columnName: columnName,
				});
			} else {
				console.error('Selected team not found');
			}
		},
		removeField(index) {
			if (this.pmsEmailMappings.length > 0) {
				this.pmsEmailMappings.splice(index, 1);
			}
		},
		insertMappingField() {
			this.pmsEmailMappings.push({ columnName: null, field: null });
		},
		addTeamMapField() {
			if (this.customPmsSettings.pmsEmailSettings.team_column) {
				this.customPmsSettings.teamMapFields.push({
					columnName: null,
					teamId: null,
					selectedTeamName: '',
				});
			} else {
				swal('Error', 'Please select a column header first.', 'error');
			}
		},
		async fetchPmsEmailSettings() {
			const type = 'email';
			const hasPmsConnection = this.teamConnections.some(
				(connection) => connection.connection_type === type,
			);
			if (!hasPmsConnection) {
				this.pmsEmailMappings = [{ columnName: null, field: null }];
				return;
			}
			try {
				const settings = await SurveysService.pmsSettings.get(type, this.team.id);
				this.parseSettings(settings);
			} catch (error) {
				console.error('Error fetching PMS Email Settings:', error);
			}
		},
		parseSettings(settings) {
			if (!settings || typeof settings !== 'object') {
				console.error('Invalid settings object:', settings);
				return;
			}

			const { pmsEmailSettings } = this.customPmsSettings;
			pmsEmailSettings.username = settings.username ?? '';
			pmsEmailSettings.password = settings.password ?? '';
			pmsEmailSettings.csv_separator = settings.csv_separator ?? '';
			pmsEmailSettings.date_format = settings.date_format ?? '';
			pmsEmailSettings.team_column = settings.team_column ?? '';
			pmsEmailSettings.mapping = settings.mapping ?? {};
			this.pmsEmailMappings = Object.entries(pmsEmailSettings.mapping).map(
				([columnName, field]) => ({ columnName, field }),
			);

			if (settings.team_map && typeof settings.team_map === 'object') {
				this.customPmsSettings.teamMapFields = Object.entries(settings.team_map).map(
					([columnName, teamId]) => ({
						columnName,
						teamId: teamId.toString(),
					}),
				);
			} else {
				console.error(
					'Expected settings.team_map to be an object, received:',
					settings.team_map,
				);
				this.customPmsSettings.teamMapFields = [];
			}
			this.convertTeamIdsToNames();
		},
		submitPmsEmailForm() {
			const allFieldsValid = this.customPmsSettings.teamMapFields.every(
				(field) => field.columnName && field.teamId !== null,
			);
			if (!allFieldsValid) {
				swal(
					'Error',
					'Please ensure all Team mappings have a Team Column and a team selected.',
					'error',
				);
				return;
			}
			const pmsEmailSettings = this.customPmsSettings.pmsEmailSettings;
			const mappingsObject = this.pmsEmailMappings.reduce((acc, { columnName, field }) => {
				if (columnName) acc[columnName] = field;
				return acc;
			}, {});
			const mappingKeysValid = Object.keys(mappingsObject).every(
				(key) => key && key !== 'null',
			);
			const mappingValuesValid = Object.values(mappingsObject).every(
				(value) => value !== null && value !== '',
			);
			if (!mappingKeysValid || !mappingValuesValid) {
				swal(
					'Error',
					'Invalid mapping detected. Please ensure there are no mappings missing from Field Map.',
					'error',
				);
				return;
			}
			const allMappingsValid = this.pmsEmailMappings.every(
				(mapping) => mapping.columnName && mapping.columnName.trim() !== '',
			);
			if (!allMappingsValid) {
				swal(
					'Error',
					'Invalid mapping detected. Please ensure no field is empty.',
					'error',
				);
				return;
			}
			this.customPmsSettings.pmsEmailSettings.mapping = mappingsObject;
			let teamMappings =
				this.customPmsSettings.teamMapFields.length > 0
					? JSON.stringify(this.customPmsSettings.teamMapFields)
					: null;
			let mappingString = JSON.stringify(mappingsObject);
			let teamColumn = pmsEmailSettings.team_column || null;
			const postData = {
				settings: {
					...pmsEmailSettings,
					team_column: teamColumn,
					team_map: teamMappings,
					mapping: mappingString,
				},
			};
			SurveysService.pmsSettings
				.post('email', this.team.id, postData)
				.then((response) => {
					this.closeModal();
					this.addConnection('email');
				})
				.catch((error) => {
					let errorMessage = 'Unknown error occurred. Please try again.';
					if (error.response && error.response.data && error.response.data.errors) {
						const errors = error.response.data.errors;
						errorMessage = Object.entries(errors)
							.map(([key, errorArray]) => {
								const fieldKey = key.split('.').pop();
								const errorType = errorArray[0].split('.').pop();
								const lookupKey = `${fieldKey}.${errorType}`;
								return (
									this.errorMessages[lookupKey] ||
									`The field ${fieldKey} has an error: ${errorArray[0]}`
								);
							})
							.join('\n');
					}
					swal('Error', errorMessage, 'error');
				});
		},
	},
};
</script>
<style scoped>
option[disabled] {
	background-color: #f0f0f0;
}
.scrollable-container {
	max-height: 250px;
	overflow-y: auto;
	overflow-x: hidden;
}

.row {
	display: flex;
	flex-wrap: wrap;
	margin-right: -6px;
	margin-left: -3px;
}

.form-icon {
	position: absolute;
	top: 17px;
	left: 0px;
}

.modal-custom {
	position: fixed;
	top: 0;
	left: 0;
	z-index: 1040;
	width: 100vw;
	height: 100vh;
	background-color: #41425ad0;
}
</style>
